import React from "react";
import Box from "@mui/material/Box";
import { useLottie } from "lottie-react";
import LoadingAnimation from "../Assets/Common/LoadingAnimationNew.json";
import { Typography } from "@mui/material";

export default function LayoutSuspensePage(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LoadingAnimation,
    style: {
      height: 180,
      width: 180,
    },
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const { View } = useLottie(defaultOptions);
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "70vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...props?.sx,
        }}
      >
        {View}
      </Box>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: "text.primary",
          mb: 0.5,
        }}
      >
        Loading…
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
        }}
      >
        Please wait while we prepare things for you
      </Typography>
    </Box>
  );
}
